<ng-template>
	<div class="btn-toolbar justify-content-between border-top pt-4 mt-4">
		<ng-content></ng-content>
	</div>
</ng-template>
